import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import {
  EventReqDtos,
  HospitalCenterReqDto,
  LeadRespDto,
  LeadsDto,
} from "../../../api/interfaces/LeadsDto";
import {
  getBookStatus,
  getDotColor,
  getEventTypes,
  getStatusClass,
  getStatusDisplayName,
} from "../../../utility/RolesUtility";
import { getService } from "../../../servce/ApisService";
import { API_ENDPOINTS } from "../../../api";
import { useLoader } from "../../../Loader/LoaderContext";
import DateService from "../../../servce/DateService";

// Define the type for the section names
type SectionName =
  | "bannerAds"
  | "emailMarketing"
  | "contentMarketing"
  | "printAdvertisement"
  | "additionalService"
  | "eNewsLetter";
const ServiceDetails = () => {
   const location = useLocation();
      const path = location.pathname;
  const navigate = useNavigate();
  const [data, setData] = useState<any>([]);
  const [searchParams] = useSearchParams();
  const userId = searchParams.get("bookingid");
  const { setLoading } = useLoader();
  const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
  const [submittedData, setSubmittedData] = useState<LeadsDto | null>(null);
  // State to track the open/closed status of each section with explicit typing
  // const [openSections, setOpenSections] = useState<{
  //   [key in SectionName]: boolean;
  // }>({
  //   bannerAds: false,
  //   emailMarketing: false,
  //   contentMarketing: false,
  //   printAdvertisement: false,
  //   additionalService:false,
  //   eNewsLetter:false,
  // });
  const [openSections, setOpenSections] = useState<Record<string, boolean>>({});

  useEffect(() => {
    fetchVehicles();
  }, []);

  const fetchVehicles = async () => {
    setLoading(true);
    try {
      let url: any;
      // if(path === '/portals/leads/ViewDetails'){

     
      const response = await getService(API_ENDPOINTS.proposalBooking + "?leadId=" + userId);

      console.log(response);
      setData(response.data);
      setTimeout(() => {
        setLoading(false)
      }, 1000);
    } catch (error) {
      setTimeout(() => {
        setLoading(false)
      }, 1000);
      console.error("Error fetching vehicle data:", error);
    } finally {
    
    }
  };

  const users = () => {
    if(path ==='portals/vendors/activeVendor/serviceDetails'){
      navigate("/portals/vendors/activeVendor");
    }else if(path === '/portals/proposals/viewProposal/serviceDetails'){
      navigate("/portals/proposals/viewProposal");
    }else if(path ==='portals/vendors/inActiveVendor/serviceDetails'){
      navigate("/portals/vendors/inActiveVendor");
    }else if(path ==='portals/bookings/confirmedBooking/serviceDetails'){
      navigate("/portals/bookings/confirmedBooking");
    }else if(path ==='portals/bookings/viewBooking/serviceDetails'){
      navigate("/portals/bookings/viewBooking");
    }
    
  };

  const getleadType: Record<string, string> = {
    COMPANY: "Company Name",
    EVENT_ORGANIZER: "Event Organiser Name",
    HOSPITAL: "Hospital Name",
  };
  const leadTypeMapping: Record<string, string> = {
    COMPANY: "Company",
    EVENT_ORGANIZER: "Event Organiser",
    HOSPITAL: "Hospital",
  };
  const leadTypeMappings: Record<string, string> = {
    COMPANY: "Company Details",
    EVENT_ORGANIZER: "Event Organiser Details",
    HOSPITAL: "Hospital Details",
  };
  const getCenterSize: Record<string, string> = {
    SMALL: "Small",
    MEDIUM: "Medium",
    LARGE: "Large",
  };

  const editProfile = (data: any) => {
    if (data?.id) {
      navigate("/portals/bookings/addBooking?bookingId=" + data?.id);
    } else {
      console.warn("Data ID is undefined");
    }
  };

  const editProposal = (data: any) => {
    if (data?.id) {
      navigate(`/portals/proposals/convertToProposal?appUserId=${data?.leadId}&companyName=${encodeURIComponent(data?.companyName)}`);
      // navigate("/portals/proposals/addProposal?appUserId=" + data?.leadId);
    } else {
      console.warn("Data ID is undefined");
    }
  };

  const toggleSection = (sectionName: string, index: number) => {
    const key = `${sectionName}-${index}`;
  
    setOpenSections((prevState) => {
      // If the clicked section is already open, close it
      if (prevState[key]) {
        return {};
      }
      // Otherwise, close all other sections and open the clicked one
      return { [key]: true };
    });
  };
  

  const handleNavigation = () => {
    navigate(-1)
    // navigate("/portals/bookings/viewBooking"); // Navigate to the desired route
  };

  return (
    <div className="h-full py-2 w-full">
      <div className="flex items-center cursor-pointer mb-4">
        <h2
          className="mr-2 text-gray-700 font-semibold text-sm"
          onClick={users}
        >
          {path ==='/portals/proposals/viewProposal/serviceDetails' ? 'Proposal' : path ==='/portals/bookings/confirmedBooking/serviceDetails' ? 'View Confirmed' : path ==='/portals/bookings/viewBooking/serviceDetails' ? 'View Booked': 'Vendors'}
        </h2>
        <img src="/images/arrowIcons.svg" className="mr-2" />
        <span className="text-gray-400 font-semibold text-sm">
          { path ==='/portals/bookings/confirmedBooking/serviceDetails' || path ==='/portals/bookings/viewBooking/serviceDetails' ? data[0]?.uuid : data[0]?.companyName ? data[0]?.companyName : "NA"}
        </span>
      </div>
      <div
        className="flex gap-2 items-center font-sans pb-7 cursor-pointer"
        onClick={handleNavigation}
      >
        <img src="/images/Back or Arrow left (1).svg" />
        <p className="text-[#2D2E2F] font-bold text-2xl">
          {path ==='/portals/bookings/confirmedBooking/serviceDetails' || path ==='/portals/bookings/viewBooking/serviceDetails' ? data[0]?.uuid  : data[0]?.companyName ? data[0]?.companyName : "NA"}
        </p>
      </div>
      {data?.map((item: LeadsDto, index: number) => (
      <div className="bg-white w-auto h-auto p-6 mb-5">
        {/* <p className="border"></p> */}
        <div className="font-Inter">
          <div className="justify-between flex pt-2 pb-4">
            <p className="font-semibold text-xl">Services for # {item?.uuid}</p>
            {/* <p className="font-semibold text-base">{item?.uuid}</p> */}
          </div>
        
          <div>
            {item?.proposalType !== "COMPANY" && (item?.isEventProfiling || item?.isHospitalProfiling || item?.isCompanyProfiling) && (
              <div className="bg-[#FFF2F5] rounded-md mb-5 flex justify-between px-4 py-3">
                <p className="text-base font-semibold ">
                  {item?.proposalType === "EVENT_ORGANIZER"
                    ? "Event Organiser Profiling" : item?.isCompanyProfiling ? 'Company Profiling'
                    : "Hospital Profiling"}
                </p>
               <span className="flex ">
                <p className="text-base font-semibold flex">{ item?.status ==='ACTIVE' ? `Activated on ${item?.activateOn ? DateService.formatDate(item?.activateOn, DateService.formats.DD_MM_YYYY) : ''}` : `Expired on ${item?.expiryDate ? DateService.formatDate(item?.expiryDate, DateService.formats.DD_MM_YYYY) : ''}`} <span className="flex items-center  w-14"></span></p></span>
              </div>
            )}
            {(item?.proposalType === "COMPANY" && item?.isCompanyProfiling) && (
              <div className="bg-[#FFF2F5] rounded-md mb-5 px-4 py-3 flex justify-center">
                <p className="text-base font-semibold ">
                Company Profiling
                </p>
                <p className="text-base font-semibold ">{ item?.status ==='ACTIVE' ? `Activated on ${item?.activateOn ? DateService.formatDate(item?.activateOn, DateService.formats.DD_MM_YYYY) : ''}` : `Expired on ${item?.expiryDate ? DateService.formatDate(item?.expiryDate, DateService.formats.DD_MM_YYYY) : ''}`}  <span className="flex items-center size-6 w-14 h-8"></span></p>
              </div>
            )}
            
            <div className="mb-5">
              {item?.isEventListing &&
              <div
                className="bg-[#FFF2F5] flex items-center justify-between cursor-pointer px-4 py-3"
                onClick={() => toggleSection("isEventListing",index)}
              >
                <p className="text-base font-semibold ">
                  Event Listing
                </p>
                <span className="flex items-center">
                <p className="text-base font-semibold ">{ item?.status ==='ACTIVE' ? `Activated on ${item?.activateOn ? DateService.formatDate(item?.activateOn, DateService.formats.DD_MM_YYYY) : ''}` : `Expired on ${item?.expiryDate ? DateService.formatDate(item?.expiryDate, DateService.formats.DD_MM_YYYY) : ''}`}</p>
                  <img
                    className={`size-6 w-14 h-8 ${
                      openSections.isEventListing
                        ? "rotate-[180deg]"
                        : "rotate-[0deg]"
                    }`}
                    src="/images/rightIcon.svg"
                  />
                </span>
              </div>
}
{openSections[`isEventListing-${index}`] && (
                <>
                  <p className="border"></p>
                  <div className="bg-[#F6F6F6] p-4 mb-5">
                    <div className="mb-5">
                      <p className="text-[#6D6D6D] font-semibold text-sm">
                        Number of Events
                      </p>
                      <p className="text-[#374151] text-base font-semibold ">
                        {item?.noOfEvents ? item?.noOfEvents : "NA"}
                      </p>
                    </div>
                    <div className="flex gap-10 mb-10">
                      <div>
                        <p className="text-[#6D6D6D] font-semibold text-sm">
                          Start date
                        </p>
                        <p className="text-[#374151] font-semibold text-sm">
                          {item?.eventListingFrom
                            ? item?.eventListingFrom
                            : "NA"}
                        </p>
                      </div>
                      <p className="border"></p>
                      <div>
                        <p className="text-[#6D6D6D] font-semibold text-sm">
                          End date
                        </p>
                        <p className="text-[#374151] font-semibold text-sm">
                          {item?.eventListingTo ? item?.eventListingTo : "NA"}
                        </p>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
 <div className="mb-5">
              {item?.isContentMarketing &&
              <div
                className="bg-[#FFF2F5] flex items-center justify-between cursor-pointer px-4 py-3"
                onClick={() => toggleSection("contentMarketing",index)}
              >
                <p className="text-base font-semibold ">
                  Content Marketing
                </p>
                <span className="flex items-center">
                <p className="text-base font-semibold ">{ item?.status ==='ACTIVE' ? `Activated on ${item?.activateOn ? DateService.formatDate(item?.activateOn, DateService.formats.DD_MM_YYYY) : ''}` : `Expired on ${item?.expiryDate ? DateService.formatDate(item?.expiryDate, DateService.formats.DD_MM_YYYY) : ''}`}</p>
                  <img
                    className={`size-6 w-14 h-8 ${
                      openSections.contentMarketing
                        ? "rotate-[180deg]"
                        : "rotate-[0deg]"
                    }`}
                    src="/images/rightIcon.svg"
                  />
                </span>
              </div>
}
{openSections[`contentMarketing-${index}`] && (
                <>
                  <p className="border"></p>
                  <div className="bg-[#F6F6F6] p-4 mb-5">
                    <div className="mb-5">
                      <p className="text-[#6D6D6D] font-semibold text-sm">
                        Number of Posts
                      </p>
                      <p className="text-[#374151] text-base font-semibold ">
                        {item?.noOfPosts ? item?.noOfPosts : "NA"}
                      </p>
                    </div>
                    <div className="flex gap-10 mb-10">
                      <div>
                        <p className="text-[#6D6D6D] font-semibold text-sm">
                          Start date
                        </p>
                        <p className="text-[#374151] font-semibold text-sm">
                          {item?.contntMarktAdFrom
                            ? item?.contntMarktAdFrom
                            : "NA"}
                        </p>
                      </div>
                      <p className="border"></p>
                      <div>
                        <p className="text-[#6D6D6D] font-semibold text-sm">
                          End date
                        </p>
                        <p className="text-[#374151] font-semibold text-sm">
                          {item?.contntMarktAdTo ? item?.contntMarktAdTo : "NA"}
                        </p>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>

            <div className="mb-5">
              {item?.isBannerAds &&
              <div
                className="bg-[#FFF2F5] flex items-center justify-between cursor-pointer px-4 py-3"
                onClick={() => toggleSection("bannerAds",index)}
              >
                <p className="text-base font-semibold ">Banner ads</p>
                <span className="flex items-center">
                <p className="text-base font-semibold ">{ item?.status ==='ACTIVE' ? `Activated on ${item?.activateOn ? DateService.formatDate(item?.activateOn, DateService.formats.DD_MM_YYYY) : ''}` : `Expired on ${item?.expiryDate}`}</p>
                  <img
                    className={`size-6 w-14 h-8 ${
                      openSections.bannerAds
                        ? "rotate-[180deg]"
                        : "rotate-[0deg]"
                    }`}
                    src="/images/rightIcon.svg"
                  />
                </span>
              </div>
}
{openSections[`bannerAds-${index}`] && (
                <>
                  <p className="border"></p>
                  <div className="bg-[#F6F6F6] p-4 mb-5">
                    <div className="flex gap-10 mb-5">
                      <div>
                        <p className="text-[#6D6D6D] font-semibold text-sm">
                          Start date
                        </p>
                        <p className="text-[#374151] font-semibold text-sm">
                          {item?.bannerAdFrom ? item?.bannerAdFrom : "NA"}
                        </p>
                      </div>
                      <p className="border"></p>
                      <div>
                        <p className="text-[#6D6D6D] font-semibold text-sm">
                          End date
                        </p>
                        <p className="text-[#374151] font-semibold text-sm">
                          {item?.bannerAdTo ? item?.bannerAdTo : "NA"}
                        </p>
                      </div>
                    </div>
                    <div>
                      <p className="text-[#6D6D6D] font-semibold text-sm">
                        Number of Banners
                      </p>
                      <p className="text-[#374151] text-base font-semibold ">
                        {item?.noOfBanners ? item?.noOfBanners : "NA"}
                      </p>
                    </div>
                  </div>
                </>
              )}
            </div>

            <div className="mb-5">
              {item?.isEmailMarketing &&
              <div
                className="bg-[#FFF2F5] flex items-center justify-between cursor-pointer px-4 py-3"
                onClick={() => toggleSection("emailMarketing",index)}
              >
                <p className="text-base font-semibold ">
                  Email Marketing
                </p>
                <span className="flex items-center">
                <p className="text-base font-semibold ">{ item?.status ==='ACTIVE' ? `Activated on ${item?.activateOn ? DateService.formatDate(item?.activateOn, DateService.formats.DD_MM_YYYY) : ''}` : `Expired on ${item?.expiryDate ? DateService.formatDate(item?.expiryDate, DateService.formats.DD_MM_YYYY) : ''}`}</p>
                  <img
                    className={`size-6 w-14 h-8 ${
                      openSections.emailMarketing
                        ? "rotate-[180deg]"
                        : "rotate-[0deg]"
                    }`}
                    src="/images/rightIcon.svg"
                  />
                </span>
              </div>
}
         {openSections[`emailMarketing-${index}`] && (    
                <>
                  <p className="border"></p>
                  <div className="bg-[#F6F6F6] p-4 mb-5">
                    <div className="mb-5">
                      <p className="text-[#6D6D6D] font-semibold text-sm">
                        Number of Counts
                      </p>
                      <p className="text-[#374151] text-base font-semibold ">
                        {item?.noOfRecipients ? item?.noOfRecipients : "NA"}
                      </p>
                    </div>
                    <div>
                      <p className="text-[#6D6D6D] font-semibold text-sm">
                        Number of EDMs
                      </p>
                      <p className="text-[#374151] text-base font-semibold ">
                        {item?.noOfEdms ? item?.noOfEdms : "NA"}
                      </p>
                    </div>
                  </div>
                </>
              )}
            </div>
            <div className="mb-5">
              {
                item?.isNewsLetterAds &&
              
              <div
                className="bg-[#FFF2F5] flex items-center justify-between cursor-pointer px-4 py-3"
                onClick={() => toggleSection("eNewsLetter",index)}
              >
                <p className="text-base font-semibold ">
                 Ads in e-newsletter
                </p>
                <span className="flex items-center">
                <p className="text-base font-semibold ">{ item?.status ==='ACTIVE' ? `Activated on ${item?.activateOn ? DateService.formatDate(item?.activateOn, DateService.formats.DD_MM_YYYY) : ''}` : `Expired on ${item?.expiryDate ? DateService.formatDate(item?.expiryDate, DateService.formats.DD_MM_YYYY) : ''}`}</p>
                  <img
                    className={`size-6 w-14 h-8 ${
                      openSections.eNewsLetter
                        ? "rotate-[180deg]"
                        : "rotate-[0deg]"
                    }`}
                    src="/images/rightIcon.svg"
                  />
                </span>
              </div>
}
               {openSections[`eNewsLetter-${index}`] && (
                 <div className="bg-[#F6F6F6] p-4 mb-5">
                 <div className="flex gap-10 mb-5">
                   <div>
                     <p className="text-[#6D6D6D] font-semibold text-sm">
                       Start date
                     </p>
                     <p className="text-[#374151] font-semibold text-sm">
                       {item?.newsLetterAdFrom ? item?.newsLetterAdFrom : "NA"}
                     </p>
                   </div>
                   <p className="border"></p>
                   <div>
                     <p className="text-[#6D6D6D] font-semibold text-sm">
                       End date
                     </p>
                     <p className="text-[#374151] font-semibold text-sm">
                       {item?.newsLetterAdTo ? item?.newsLetterAdTo : "NA"}
                     </p>
                   </div>
                 </div>
                 <div>
                   <p className="text-[#6D6D6D] font-semibold text-sm">
                     Number of e-newsletter
                   </p>
                   <p className="text-[#374151] text-base font-semibold ">
                     {item?.noOfNewsBanners ? item?.noOfNewsBanners : "NA"}
                   </p>
                 </div>
               </div>
              )}
            </div>

           
            <div className="mb-5">
              {item?.isPrintAd &&
              <div
                className="bg-[#FFF2F5] flex items-center justify-between cursor-pointer px-4 py-3"
                onClick={() => toggleSection("printAdvertisement",index)}
              >
                <p className="text-base font-semibold">
                  Print Advertisement
                </p>
                <span className="flex items-center">
                <p className="text-base font-semibold ">{ item?.status ==='ACTIVE' ? `Activated on ${item?.activateOn ? DateService.formatDate(item?.activateOn, DateService.formats.DD_MM_YYYY) : ''}` : `Expired on ${item?.expiryDate ? DateService.formatDate(item?.expiryDate, DateService.formats.DD_MM_YYYY) : ''}`}</p>
                  <img
                    className={`size-6 w-14 h-8 ${
                      openSections.printAdvertisement
                        ? "rotate-[180deg]"
                        : "rotate-[0deg]"
                    }`}
                    src="/images/rightIcon.svg"
                  />
                </span>
              </div>
}
              {openSections[`printAdvertisement-${index}`] && (
                <>
                  <p className="border"></p>
                  <div className="bg-[#F6F6F6] p-4 mb-5">
                    <div className="mb-5">
                      <p className="text-[#6D6D6D] font-semibold text-sm">
                        Number of Advertisements
                      </p>
                      <p className="text-[#374151] text-base font-semibold ">
                        {item?.printAdd ? item?.printAdd : "NA"}
                      </p>
                    </div>
                    <div className="mb-5">
                      <p className="text-[#6D6D6D] font-semibold text-sm">
                        Number of Issues
                      </p>
                      <p className="text-[#374151] text-base font-semibold ">
                        {item?.noOfPrintAds ? item?.noOfPrintAds : "NA"}
                      </p>
                    </div>
                  </div>
                </>
              )}
            </div>
            {item?.proposalType !== "EVENT_ORGANIZER" && (
              <>
              {item?.additionalService &&
            <div
                className="bg-[#FFF2F5] flex items-center justify-between cursor-pointer px-4 py-3"
                onClick={() => toggleSection("additionalService",index)}
              >
                <p className="text-base font-semibold ">
                Additional Services
                </p>
                <span className="flex items-center">
                {/* <p className="text-base font-semibold ">{ item?.status ==='ACTIVE' ? `Activated on ${item?.activateOn ? DateService.formatDate(item?.activateOn, DateService.formats.DD_MM_YYYY) : ''}` : `Expired on ${item?.expiryDate ? DateService.formatDate(item?.expiryDate, DateService.formats.DD_MM_YYYY) : ''}`}</p> */}
                  <img
                    className={`size-6 w-14 h-8 ${
                      openSections.additionalService
                        ? "rotate-[180deg]"
                        : "rotate-[0deg]"
                    }`}
                    src="/images/rightIcon.svg"
                  />
                </span>
              </div>
}
              {openSections[`additionalService-${index}`] && (
                <>
                  <p className="border"></p>
                  <div className="bg-[#F6F6F6] p-4 mb-5">
                    <div className="mb-5">
                      <p className="text-[#6D6D6D] font-semibold text-sm">
                      Additional Services
                      </p>
                      <p className="text-[#374151] text-base font-semibold ">
                        {item?.additionalService ? item?.additionalService : "NA"}
                      </p>
                    </div>
                  </div>
                </>
              )}
              </>
            )}
            
          </div>
        </div>
      </div>
      ))}
    </div>
  );
};

export default ServiceDetails
